import { memo, useCallback, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { Badge, Button, Flex, Form, Skeleton, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { BoardService } from "../../services/BoardService";
import { mdlBoardCreateRequest } from "../../models/service-models/board/BoardCreateRequest";
import { mdlBoardUpdateRequest } from "../../models/service-models/board/BoardUpdateRequest";
import { mdlBoardDetailRequest } from "../../models/service-models/board/BoardDetailRequest";
import TextArea from "antd/es/input/TextArea";
import { SystemBoardSelect } from "../common/SystemBoardSelect";

export type BoardDetailProps = {
    id?: string;
    hotelId?: string;
    callback?: Function;
}


export const BoardDetail = memo(function BoardDetail(props: BoardDetailProps) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    useEffect(() => {
        if (!props.id && form) {
            form.resetFields(); // ID yoksa formu sıfırla
        }
    }, [props.id, form]);



    const {
        data,
        isLoading,
        isError,
        isFetched,
        refetch: getBoardDetail
    } = useQuery(
        ["getBoardDetail", props.id],
        () => {
            if (props.id) {
                var request: mdlBoardDetailRequest = { id: props.id };
                return BoardService.Detail(request);
            }
        },
        {
            staleTime: 0,
            refetchOnWindowFocus: false,
            enabled: !!props.id,
        }
    );
    useEffect(() => {
        if (data && form) {
            form.setFieldsValue({ systemBoardId: data.body?.data.accommodationTypeId, description: data.body?.data.description });
        }
    }, [data, form]);
    const { mutateAsync: saveBoard, isLoading: mutateLoading, data: mutateData } = useMutation(
        (data: mdlBoardCreateRequest & mdlBoardUpdateRequest) => props.id ? BoardService.Update(data as mdlBoardUpdateRequest) : BoardService.Create(data as mdlBoardCreateRequest),
        {
            onMutate(variables) {
                variables.hotelId = props.hotelId;
                variables.id = props.id!
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body?.isSuccessful) {
                    toast.success(t("common.success"));
                    form.resetFields();
                    props.callback && props.callback();
                }
                else {
                    toast.error((data.header.messages && data.header.messages?.length > 0) ?
                        ObjectHelper.getErrorMessage(data.header.messages) : data.body?.message);
                }
            },
        }
    );

    return (
        <>
            {
                !isLoading
                &&
                ((props.id && isFetched) || !props.id)
                &&
                <Spin spinning={mutateLoading}>
                    <Form
                        form={form}
                        initialValues={{ description: data?.body?.data.description, accomTypeId: data?.body?.data.accommodationTypeId }}
                        name="board-form"
                        layout="vertical"
                        onFinish={async (values) => saveBoard(values)}
                        autoComplete="off"
                    >
                        <Form.Item<mdlBoardUpdateRequest | mdlBoardCreateRequest>
                            label={t("definitions.boards.systemBoards")}
                            name="accomTypeId"
                            rules={[{ required: true, message: t("common.required") }]}
                        >
                            <SystemBoardSelect onChange={(value: string) => form.setFieldsValue({ accommodationTypeId: value })} />
                        </Form.Item>
                        <Form.Item<mdlBoardUpdateRequest | mdlBoardCreateRequest>
                            label={t("definitions.boards.description")}
                            name="description"
                        >
                            <TextArea rows={4} />
                        </Form.Item>

                        <Form.Item>
                            <Flex align={"center"} justify="flex-end">
                                <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                            </Flex>
                        </Form.Item>
                    </Form>
                </Spin>
            }
        </>
    )
})
